import * as types from './constants';

export const openAiAssistant = mode => (
	{ type: types.OPEN_AI_ASSISTANT, payload: mode }
);

export const closeAiAssistant = () => (
	{ type: types.CLOSE_AI_ASSISTANT }
);

export const setAiAssistantMode = mode => (
	{ type: types.SET_AI_ASSISTANT_MODE, payload: mode }
);

// Opens the assistant and sends `prompt` as the user's first message
export const openAiAssistantWithPrompt = prompt => (
	{ type: types.OPEN_AI_ASSISTANT_WITH_PROMPT, payload: prompt }
);

export const clearAiAssistantPrompt = () => (
	{ type: types.CLEAR_AI_ASSISTANT_PROMPT }
);

// The chat agent answered 429 (AI tokens used up); there's no way to ask for it up front
export const setAiAssistantTokenLimitReached = () => (
	{ type: types.SET_AI_ASSISTANT_TOKEN_LIMIT_REACHED }
);
